import { mapActionsFromConfigurations } from '../../helpers/action';
import { configurations } from './configurations';
import { apiAction as getCpdCategorys } from './configurations/cpdCategorys';
import { apiAction as get } from './configurations/get';
import { apiAction as getRoles } from './configurations/roles';

export const apiActions = {
  industries: {
    get,
    getRoles,
    getCpdCategorys
  }
}

const actions = mapActionsFromConfigurations('industries')(configurations);

export * from './configurations/endpoints';

export default actions;


// WEBPACK FOOTER //
// ./src/state/modules/industry/actions.js